import { render, staticRenderFns } from "./QcInspection.vue?vue&type=template&id=f95f864e"
import script from "./QcInspection.vue?vue&type=script&lang=js"
export * from "./QcInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports